const AI_STATS_REQUEST_CONFIG = { paramsSerializer: { indexes: null } };

export class AiStatsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getCost(params) {
    return this.#http.get('/ai-stats/cost', { params, ...AI_STATS_REQUEST_CONFIG });
  }

  async getQuality(params) {
    return this.#http.get('/ai-stats/quality', { params, ...AI_STATS_REQUEST_CONFIG });
  }

  async getWaste(params) {
    return this.#http.get('/ai-stats/waste', { params, ...AI_STATS_REQUEST_CONFIG });
  }

  async getFeedback(params) {
    return this.#http.get('/ai-stats/feedback', { params, ...AI_STATS_REQUEST_CONFIG });
  }
}
